import { Typography, Grid, List, ListItem, Link } from '@mui/material';
import { colors } from 'src/components/App/colors';

const CPRFormContent = () => {
  return (
    <Grid container>
      <Typography sx={{ color: colors['charcoal.700'], mb: 2 }} variant={'body2'}>
        Use this form to record cardiopulmonary resuscitation (CPR) courses.
      </Typography>
      <Typography sx={{ color: colors['charcoal.700'], mb: 2 }} variant={'body2'}>
        The RACGP’s specialist high-level requirement for general practice is to complete a
        cardiopulmonary resuscitation (CPR) course at least once per triennium. While CPR is a GP
        specialist high-level requirement, this form can be used by anyone who has completed CPR as
        part of their CPD.
      </Typography>
      <Typography sx={{ color: colors['charcoal.700'], fontWeight: 600 }} variant={'body2'}>
        Please note that:
      </Typography>

      <List
        sx={{
          color: colors['charcoal.700'],
          listStyleType: 'disc',
          width: '100%',
          listStylePosition: 'outside',
          pl: 3
        }}
      >
        <ListItem sx={{ display: 'list-item', p: 0 }}>
          <Typography sx={{ color: colors['charcoal.700'] }} variant={'body2'}>
            CPR must meet the Australian Resuscitation Council and New Zealand Committee on
            Resuscitation (ANZCOR) guidelines. CPD certification may also be accepted from other
            members of the International Liaison Committee on Resuscitation (ILCOR).
          </Typography>
        </ListItem>
        <ListItem sx={{ display: 'list-item', p: 0 }}>
          <Typography sx={{ color: colors['charcoal.700'] }} variant={'body2'}>
            The course must be a minimum of one hour duration.
          </Typography>
        </ListItem>
        <ListItem sx={{ display: 'list-item', p: 0 }}>
          <Typography sx={{ color: colors['charcoal.700'] }} variant={'body2'}>
            You can record a maximum of four hours for your completion of a CPR only course (longer
            courses, such as First aid, that include CPR may be recorded for the full course
            duration).
          </Typography>
        </ListItem>
        <ListItem sx={{ display: 'list-item', p: 0 }}>
          <Typography sx={{ color: colors['charcoal.700'] }} variant={'body2'}>
            CPR competency must be practically assessed (theory only courses do not meet the
            requirement).
          </Typography>
        </ListItem>
        <ListItem sx={{ display: 'list-item', p: 0 }}>
          <Typography sx={{ color: colors['charcoal.700'] }} variant={'body2'}>
            Neonatal CPR does not satisfy the RACGP's CPR requirements.
          </Typography>
        </ListItem>
      </List>
      <Typography sx={{ color: colors['charcoal.700'] }} variant={'body2'}>
        To record your Advanced Life Support completion, please use{' '}
        <Link rel="noreferrer" href="/als">
          Advanced Life Support form.
        </Link>
      </Typography>
    </Grid>
  );
};
export { CPRFormContent };
